export const PERMISSION_ADMIN = 'admin';
export const PERMISSION_COMPANY = 'CompanyProfile';
export const PERMISSION_COMPANY_ADMIN = 'CompanyAdmin';
export const PERMISSION_EMPLOYEE = 'Employee';

export const PERMISSION_ALL = [PERMISSION_ADMIN, PERMISSION_COMPANY, PERMISSION_COMPANY_ADMIN];
export const PERMISSION_COMPANY_PANEL = [PERMISSION_EMPLOYEE];